import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

// Naming follows the conventions established in the WebGL package.
// Ref: https://github.com/github/brand-refactor-webgl
export const BrandEnum = z.enum(['Copilot', 'Security'])
export type Brand = z.infer<typeof BrandEnum>

export const OverviewTemplateSettingsSchema = buildEntrySchemaFor('overviewTemplateSettings', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      brand: safeOptional(BrandEnum),
    }),
  ),
})
export type OverviewTemplateSettings = z.infer<typeof OverviewTemplateSettingsSchema>
